import { render } from "./ContextMenuIconRight.vue?vue&type=template&id=41a351a6"
const script = {}

import exportComponent from "D:\\Code\\GitHub\\vue3-context-menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__